import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort ,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { Router } from '@angular/router';

import 'rxjs/add/observable/of';
import { FiltrosLiquidaciones } from 'app/models/FiltrosLiquidaciones';
import { LiquidacionService } from 'app/services/liquidacion/liquidacion.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-listado-liquidaciones',
  templateUrl: './listado-liquidaciones.component.html',
  styleUrls: ['./listado-liquidaciones.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoLiquidacionesComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  DTOFiltrosLiquidaciones: FiltrosLiquidaciones = new FiltrosLiquidaciones();
  loading:boolean;
  data :any = [];
  idLiquidacion: number = 0;
  liquidaciones : any = [];
  user:any;
  ruc = new FormControl();
  rucAdq = new FormControl('');
  idProv;
  idAdq = "";
  form : FormGroup;
  proveedoresArr;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  abrirPopUp:boolean = false;
  abrirDetalle:boolean = false;
  filteredProveeedor: Observable<any[]>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns = [ 'checked','Documento','idLiquidacion','Razon_Social_Proveedor','Razon_Social_Adquirente','Fecha','Fecha_Pago_Real','Moneda', 'Interes_Proveedor_Diferencia','Liquidación_Proveedor','Estado'];
  dataSource: any;
  constructor(private datePipe:DatePipe,private router:Router,private LiquidacionService1:LiquidacionService) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ObtenerProveedorCombo();
    this.ObtenerAdquirentesCombo();
    this.DTOFiltrosLiquidaciones.FechaIni = this.datePipe.transform(moment().add(-30, 'day'),'yyyy-MM-dd');
    this.DTOFiltrosLiquidaciones.FechaFin = this.datePipe.transform(moment(),'yyyy-MM-dd');
   }

  ngOnInit() {
    this.ListadoLiquidacionesFiltro()
  }

  tipoMoneda(event){
    if(event==''){
      this.DTOFiltrosLiquidaciones.Moneda=0;
    }else{
      this.DTOFiltrosLiquidaciones.Moneda = event;
    }  
  }


  private _filterProv(value:string):any[]{
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(state => state.Razon_Social.toLowerCase().includes(filterValue) === true);
  }

  ObtenerProveedorCombo(){
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
    .pipe(
        startWith(""),
        map(state =>
            state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
    );
  }
      
  obtenerIdProv(termino:string){
    this.idProv = termino;
    this.DTOFiltrosLiquidaciones.IdProv = termino;
  }
    
  EnteroObtenerRucRazSocialProv(termino:string = ''){
    if(termino != null && termino != ''){
      let termino1 = termino.toLowerCase();
      for(let p of this.proveedoresArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if(raz.indexOf(termino1) >=0){
          this.idProv = p.idEmpresa;
          this.DTOFiltrosLiquidaciones.IdProv = p.idEmpresa;
        }
      }
    }
  }

  EnteroObtenerRucRazSocialAdq(termino:string = ''){
    if(termino != null && termino != ''){
      let termino1 = termino.toLowerCase();
      for(let p of this.adquirentessArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if(raz.indexOf(termino1) >=0){
          this.idAdq = p.idEmpresa;
          this.DTOFiltrosLiquidaciones.IdAdq = p.idEmpresa;
        }
      }
    }
  }

  ObtenerAdquirentesCombo() {
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentessArr.slice()
        )
      );
  }

 
 

  obtenerRucAdq(termino: string) {
    this.idAdq = termino;
    this.DTOFiltrosLiquidaciones.IdAdq = termino;
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentessArr.filter(state => state.Razon_Social.toLowerCase().includes(filterValue) === true);
  
  }


  ListadoLiquidacionesFiltro(){
    console.log('data',this.DTOFiltrosLiquidaciones)
    this.loading = true;

    if (this.ruc.value == null || this.ruc.value == ""){
      this.idProv = "0";
      this.DTOFiltrosLiquidaciones.IdProv = "0";
    }
    if (this.rucAdq.value == null || this.rucAdq.value == ""){
      this.idAdq = "0";
      this.DTOFiltrosLiquidaciones.IdAdq = "0";
    }
        
    this.DTOFiltrosLiquidaciones.FechaIni = this.datePipe.transform(this.DTOFiltrosLiquidaciones.FechaIni,'yyyy-MM-dd')
    this.DTOFiltrosLiquidaciones.FechaFin = this.datePipe.transform(this.DTOFiltrosLiquidaciones.FechaFin,'yyyy-MM-dd')

    this.LiquidacionService1.obtenerLiquidaciones(this.DTOFiltrosLiquidaciones).subscribe(
      res =>{
          this.liquidaciones = res;
          this.dataSource = new MatTableDataSource( this.liquidaciones);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
      },err =>{
          Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false 
          });
          this.loading = false;
      }
    )
  }

  
  darBajaLiquidacion(idLiquidacion){
    Swal.fire({
        title:'',
        text:'¿Estás seguro en dar de baja la liquidación?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText:'Si,dar de baja.',
        cancelButtonText: 'No, cancelar',
        reverseButtons: true,
        heightAuto: false
    }).then((result)=>{
        if(result.value){
          Swal.fire({
            title: '¡Espere!',
            html: 'Procesando solicitud.',
            heightAuto: false
          })
          Swal.showLoading();
          this.form = new FormGroup({
            'idLiquidacion' : new FormControl(idLiquidacion),
            'usuario': new FormControl(this.user.Usuario) ,
            'canal': new FormControl('W') 
          })
            this.LiquidacionService1.bajaEstadoLiquidacion(this.form.getRawValue())
            .subscribe(res=>{
              Swal.fire({
                title: '¡Documento dado de baja',
                text: 'El documento fue dado de baja exitosamente.',
                type: 'success',
                heightAuto: false
              }).then(resp =>{
                if(resp.value == true){
                  this.ListadoLiquidacionesFiltro();
                }
              });
            },
            err => {
              Swal.fire({
                title: "Error",
                text: "No se pudo dar de baja la liquidacion.",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });
            })
        }
    })
  } 

  obtenerpdf($file:any){
    window.open($file,"_blank");
  }

  AbrirPopUpCorreo(element:any){
    this.abrirPopUp = true;
    this.LiquidacionService1.proveedorCorreo = element;
  }

  AbrirDetalle(element){
    this.abrirDetalle = true;
    this.LiquidacionService1.detalleLiquidacion = element;
  }

  CerrarDetalle(){
    this.abrirDetalle=false;
  }

  CerrarPopUp(){
    this.abrirPopUp = false;
  }


}
